import { SubscriptionIntegrationSchema } from "@redotech/redo-model/subscription-integrations/subscription-integration";
import * as z from "zod/v4";

export const cancelSubscription = {
  name: "cancelSubscription" as const,
  input: z.object({
    subscriptionId: z.number(),
    cancellationReason: z.string().optional(),
  }),
  output: z.object({ subscription: SubscriptionIntegrationSchema }),
};
